
// @flow
export const SUBSIDY_TYPE_COMMON: 'common' = 'common';
export const SUBSIDY_TYPE_PERSONAL: 'personal' = 'personal';
export const SUBSIDY_TYPE_ALL: 'all' = 'all';
